
import moment from "moment";

export const toDate = (datetime) =>{
    return moment(datetime).utc().format('DD/MM/YYYY');
   }

export const toDateShort = (datetime) =>{
    return moment(datetime).utc().format('DD/MM/YY');
   }

export const toTime = (datetime) =>{    
    return moment(datetime).utc().format('HH:mm');
   }

export const ToDateTime = (datetime) =>{
        return moment(datetime).utc().format('DD/MM/YYYY HH:mm');
   }
   
export const ToShortDateTime = (datetime) =>{
    return moment(datetime).utc().format('DD/MM/YY HH:mm');
}
